// extracted by mini-css-extract-plugin
module.exports = {"blog__list":"styles_blog__list__2rmtq"};